export default __webpack_public_path__ + "static/media/backupPhrase.a6929a16.svg";